<template>
    <ul class="pagination">
        <li :class="{ disabled: source.current_page === 1 }">
            <a href="#" @click.prevent="nextPrev($event, source.current_page-1)">
                <i class="fa fa-angle-left"></i>
            </a>
        </li>
        <li v-for="page in pages" track-by="$index" :class="{ active: source.current_page === page }">
            <span v-if="page === '...'">{{ page }}</span>
            <a href="#" v-if="page !== '...'" @click.prevent="navigate(page)">{{ page }} </a>
        </li>
        <li :class="{ disabled: source.current_page === source.last_page }">
            <a href="#" @click.prevent="nextPrev($event, source.current_page+1)">
                <i class="fa fa-angle-right"></i>
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'Pagination',
        props: ['source'],
        data () {
            return {
                pages: []
            }
        },
        mounted () {
            this.init()
        },
        methods: {
            navigate (page) {
                this.$emit('navigate', page)
            },
            nextPrev (e, page) {
                if (page === 0 || page === this.source.last_page + 1) return
                this.navigate(page)
            },
            generatePagesArray (currentPage, collectionLength, rowsPerPage, paginationRange) {
                let pages = []
                let totalPages = Math.ceil(collectionLength / rowsPerPage)
                let halfWay = Math.ceil(paginationRange / 2)
                let ellipsesNeeded = paginationRange < totalPages

                let position = 'middle'

                if (currentPage <= halfWay)
                    position = 'start'
                else if (totalPages - halfWay < currentPage)
                    position = 'end'

                let i = 1

                while (i <= totalPages && i <= paginationRange) {
                    let pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages)
                    let openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'))
                    let closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'))

                    if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded))
                        pages.push('...')
                    else
                        pages.push(pageNumber)

                    i++
                }
                return pages
            },
            calculatePageNumber (i, currentPage, paginationRange, totalPages) {
                let halfWay = Math.ceil(paginationRange / 2)

                if (i === paginationRange)
                    return totalPages
                else if (i === 1)
                    return i
                else if (paginationRange < totalPages)
                    if (totalPages - halfWay < currentPage)
                        return totalPages - paginationRange + i
                    else if (halfWay < currentPage)
                        return currentPage - halfWay + i
                    else
                        return i
                else
                    return i
            },
            init () {
                let s = this.source
                this.pages = this.generatePagesArray(s.current_page, s.total, s.per_page, 12)
            }
        },
        watch: {
            source () {
                this.init()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/helpers/Pagination.vue